import { VersionApi } from './version-api.model';
import { Platform } from '@shared/enums/platform.enum';

export class Version {
  platform: Platform;
  current: string;
  minimum: string;

  constructor(resource: VersionApi) {
    this.platform = resource.platform;
    this.current = resource.version.current;
    this.minimum = resource.version.minimum;
  }

  /**
   * Returns true when appVersion is strictly below minimum.
   * Compares dot-separated numeric segments, e.g. "1.2.3" vs "1.3.0".
   */
  isOutdated(appVersion: string): boolean {
    return Version.isVersionBelow(appVersion, this.minimum);
  }

  static isVersionBelow(version: string, minimum: string): boolean {
    const versionSegments = version.split('.').map(Number);
    const minimumSegments = minimum.split('.').map(Number);
    const length = Math.max(versionSegments.length, minimumSegments.length);

    for (let index = 0; index < length; index++) {
      const versionSegment = versionSegments[index] ?? 0;
      const minimumSegment = minimumSegments[index] ?? 0;

      if (versionSegment < minimumSegment) {
        return true;
      }

      if (versionSegment > minimumSegment) {
        return false;
      }
    }

    return false;
  }
}
